export function resolveSubObjectKey(obj: any, key: string): any {
  return key.split('.').reduce((elem, k) => elem?.[k], obj);
}
